import { Modal } from "react-bootstrap";
import server1 from "../../assets/images/illustrations/Web hosting data center Jakarta 1.webp";
import server2 from "../../assets/images/illustrations/Web hosting data center Jakarta 2.webp";
import server3 from "../../assets/images/illustrations/Web hosting data center Bandung.webp";

const dataCenters = [
  {
    imgSrc: server1,
    alt: "Web hosting data center Jakarta 1",
    title: "Web hosting data center Jakarta 1",
    name: "Cyber Data Center (SouthJKT-1)",
    address: "Gedung Cyber 1 lt.3, Kuningan Barat, Jakarta Selatan",
    features: [
      "Private Data Center Tier 3",
      "Sertifikasi ISO 27001:2013",
      "24/7 Support Layanan Pelanggan",
      "24/7 Onsite & Offsite Staff Monitoring",
      "24/7 Maximum Security, Akses Keamanan Bertingkat",
      "Generator, Fire Extinguisher, Precision Air Conditioning Control",
      "Multiple Premium Connection 10Gbps",
    ],
  },
  {
    imgSrc: server2,
    alt: "Web hosting data center Jakarta 2",
    title: "Web hosting data center Jakarta 2",
    name: "MTEN Data Center (SouthJKT-2)",
    address: "MTEN (Menara Tendean) lt.6, Kapten Tendean, Jakarta Selatan",
    features: [
      "Private Data Center Tier 3",
      "Sertifikasi ISO 27001:2013",
      "24/7 Support Layanan Pelanggan",
      "24/7 Onsite & Offsite Staff Monitoring",
      "24/7 Maximum Security, Akses Keamanan Bertingkat",
      "Generator, Fire Extinguisher, Precision Air Conditioning Control",
      "Multiple Premium Connection 10Gbps",
    ],
  },
  {
    imgSrc: server3,
    alt: "Web hosting data center Bandung",
    title: "Web hosting data center Bandung",
    name: "Bandung Data Center (WestJavaBDG-1)",
    address: "Jl. Asia Afrika No.141-149 Kota Bandung, Jawa Barat",
    features: [
      "Private Data Center Tier 3",
      "Sertifikasi ISO 27001:2013",
      "24/7 Support Layanan Pelanggan",
      "24/7 Onsite & Offsite Staff Monitoring",
      "24/7 Maximum Security, Akses Keamanan Bertingkat",
      "Generator, Fire Extinguisher, Precision Air Conditioning Control",
      "Multiple Premium Connection 10Gbps",
    ],
  },
];

const DataCenterCard = ({ imgSrc, alt, title, name, address, features }) => (
  <div className="col-12 col-lg-4 mb-3">
    <div
      style={{ backgroundColor: "#fff8f3" }}
      className="card border-0 shadow p-2 rounded-4 h-100"
    >
      <div className="col-lg-12">
        <div className="img-wrapper mx-auto rounded-4 p-3">
          <img className="w-100" src={imgSrc} alt={alt} title={title} />
        </div>
        <div className="col-12 col-lg-12 text-center mt-4">
          <h6 className="fw-bold">{name}</h6>
          <h6 style={{ fontSize: "14px" }} className="fw-bold">
            {address}
          </h6>
        </div>
        <div className="card-description mt-4" style={{ fontSize: "13px" }}>
          <ul>
            {features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

const ModalLokasi = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xl"
      backdrop="false"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Detail Lokasi Server</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row justify-content-center mt-3">
          {dataCenters.map((center, index) => (
            <DataCenterCard key={index} {...center} />
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalLokasi;
